import Vue from 'vue';
import Vuex from 'vuex';
import { getBrandConfig } from '../api/userMG';

Vue.use(Vuex);

const DEFAULT_BRAND = {
    systemName: '',
    logoUrl: 'static/title.png',
    faviconUrl: './static/favicon.ico',
    copyright: 'Copyright © 2021北京爱才科技有限公司'
};

function unwrapBrand(payload) {
    if (!payload || typeof payload !== 'object') {
        return {};
    }
    const nested = payload.data;
    if (nested && typeof nested === 'object' && (
        nested.systemName || nested.system_name || nested.logoUrl || nested.logo_url ||
        nested.faviconUrl || nested.favicon_url
    )) {
        return nested;
    }
    return payload;
}

function resolveMediaUrl(url) {
    if (!url) return '';
    let src = String(url).trim();
    if (!src) return '';
    if (typeof window !== 'undefined' && window.location.protocol === 'https:' && /^http:\/\//i.test(src)) {
        try {
            const u = new URL(src);
            const pageHost = window.location.hostname;
            if (u.hostname === pageHost || u.hostname.endsWith('.' + pageHost)) {
                src = 'https://' + src.slice('http://'.length);
            }
        } catch (e) {
            /* ignore */
        }
    }
    return src;
}

function normalizeBrand(payload) {
    const src = unwrapBrand(payload);
    const hasPayload = !!(src && (
        src.systemName != null || src.system_name != null ||
        src.logoUrl || src.logo_url || src.faviconUrl || src.favicon_url ||
        src.copyright || src.domain
    ));
    const rawName = src.systemName != null ? src.systemName : src.system_name;
    const trimmedName = rawName != null ? String(rawName).trim() : '';
    // 接口有返回时：空名称保持为空；接口失败走默认
    const systemName = trimmedName || (hasPayload ? '' : DEFAULT_BRAND.systemName);
    const logoUrl = resolveMediaUrl(src.logoUrl || src.logo_url || '');
    const faviconUrl = resolveMediaUrl(src.faviconUrl || src.favicon_url || '');
    return {
        systemName: systemName,
        logoUrl: logoUrl || (hasPayload ? '' : DEFAULT_BRAND.logoUrl),
        faviconUrl: faviconUrl || (hasPayload ? '' : DEFAULT_BRAND.faviconUrl),
        copyright: src.copyright || (hasPayload ? '' : DEFAULT_BRAND.copyright)
    };
}

function isSignedMediaUrl(url) {
    return /[?&]X-Amz-/i.test(url) || /[?&]Signature=/i.test(url);
}

function guessFaviconType(url) {
    const path = String(url).split('?')[0].toLowerCase();
    if (path.endsWith('.png')) return 'image/png';
    if (path.endsWith('.svg')) return 'image/svg+xml';
    if (path.endsWith('.jpg') || path.endsWith('.jpeg')) return 'image/jpeg';
    if (path.endsWith('.gif')) return 'image/gif';
    if (path.endsWith('.webp')) return 'image/webp';
    if (path.endsWith('.ico')) return 'image/x-icon';
    return '';
}

function applyBrandToDocument(brand) {
    if (brand.systemName) {
        document.title = brand.systemName;
    }
    const faviconUrl = (brand.faviconUrl || '').trim();
    if (!faviconUrl) {
        return;
    }
    // 预签名 URL 不能追加 &_t=，否则签名校验失败
    let href = faviconUrl;
    if (!isSignedMediaUrl(faviconUrl)) {
        href =
            faviconUrl +
            (faviconUrl.indexOf('?') > -1 ? '&' : '?') +
            '_t=' +
            Date.now();
    }
    const type = guessFaviconType(faviconUrl);
    document.querySelectorAll("link[rel*='icon']").forEach((el) => {
        el.parentNode && el.parentNode.removeChild(el);
    });
    const link = document.createElement('link');
    link.rel = 'icon';
    if (type) link.type = type;
    link.href = href;
    document.head.appendChild(link);
}

// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        brand: Object.assign({}, DEFAULT_BRAND)
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfo", "");
        },
        setBrand(state, payload) {
            state.brand = normalizeBrand(payload);
            applyBrandToDocument(state.brand);
        }
    },
    actions: {
        fetchBrand({ commit }) {
            return getBrandConfig()
                .then((res) => {
                    commit('setBrand', res);
                })
                .catch(() => {
                    commit('setBrand', DEFAULT_BRAND);
                });
        }
    }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js